import React from 'react'
import { Link, CtaArrow } from 'newComponents'
import './styles.scss'

const CaseStudyLandingHero = ({ content }) => {
  const { title, tagline, primaryCTAText, primaryCTAUrl, secondaryCTAText, secondaryCTAURL } = content
  return (
    <div className="bg-gradient-reverse">
      <div className="container case-studies-landing-hero-content">
        <div className="case-studies-landing-hero-content-inner">
          <p className="overline-title">Case Studies</p>
          <h1 className="title">{title}</h1>
          <p className="text-large">{tagline}</p>
          <div className="cta-btn-group">
            {primaryCTAUrl && (
              <Link to={primaryCTAUrl} className="button is-large is-primary border-radius-2">
                {primaryCTAText}
              </Link>
            )}
            {secondaryCTAURL && (
              <Link className="secondary-button" to={secondaryCTAURL}>
                {secondaryCTAText}
                <CtaArrow />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CaseStudyLandingHero
